/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceSearchFilterSchema = z.object({
  holidaySchemeIds: z.array(z.int()).nullish(),
  locationIds: z.array(z.int()).nullish(),
  loopIds: z.array(z.int()).nullish(),
  query: z.string(),
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED']).nullish(),
  roleIds: z.array(z.int()).nullish(),
  skillIds: z.array(z.int()).nullish(),
  workforceCategories: z
    .array(z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']))
    .nullish(),
  workloadSchemeIds: z.array(z.int()).nullish(),
});
